import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { AccommodationHotelPolicyI18nFormModel } from "../type";

type Props = {
	hotelID: string;
	lang: LangCode;
	id: string;
	queryData: AccommodationHotelPolicyI18nFormModel["QueryData"];
};

export const DEFAULT_ACCOMMODATION_HOTEL_POLICY_I18N_INPUT_MODEL = ({
	hotelID,
	lang,
	id,
	queryData: _queryData,
}: Props) => {
	const inputModel: AccommodationHotelPolicyI18nFormModel["InputModel"] = {
		hotelID,
		id,
		lang,
		hotelInfo: [],
		additionalFees: [],

		questions: [] satisfies AccommodationHotelPolicyI18nFormModel["InputModel"]["questions"],
	} satisfies AccommodationHotelPolicyI18nFormModel["InputModel"];

	return inputModel;
};
